import React from "react";
import { connect } from "react-redux";
import cloneDeep from 'lodash/cloneDeep';

import PharamacyInfoModel from "./PharamacyInfoModel";
import OurStepManager from "../../common/OurStepManager";
import NonBSWPharamacyInfo from "./NonBSWPharamacyInfo";
import TransferPharmacy from "./TransferPharmacy";
import TransferConfirmation from "./TransferConfirmation";
import TransferReview from "./TransferReview";
import PharmacyHeader from "../PharmacyHeader";
import ConfirmationModal from "../../common/ConfirmationModal";
import { getAddressUrl } from "../../../helpers/location";

import * as types from "../../../constants/actionTypes";
import * as d from "../../../reducers/domainReducer";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

class NonBSWTransfer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transferData: cloneDeep(PharamacyInfoModel), //deep clone as state is updating this object.
            destinationPharmacy: null, transferCompleted: false
        };
        this.baseURL = window.location.pathname;
        this.addressUrl = '#';
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.NonBSWTransfer.ComponentDidMount", new Date(), Tools.getURLPath());
        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (location.pathname.toLowerCase().indexOf('nonbswtransfer') > -1) {
                // This is a trick to re-activate the ConfirmationModal and a fix to bug# 39008.
                // When switching to a pharmacy user, this form is not re-loaded and without the below line of code, 
                // the modal assumes that confirmation happened already and won't show up when an attempt to leave the form happens next time.
                this.setState({ hideModal: true }, () => this.setState({ hideModal: false }));
            }
        });
    }

    componentWillUnmount() {
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    onPharmacySelected = (destinationPharmacy) => {
        this.scrollToTop();
        this.addressUrl = getAddressUrl(destinationPharmacy.Address);
        this.setState({
            transferData: { ...this.state.transferData, BSWStoreNumber: destinationPharmacy.StoreNumber },
            destinationPharmacy
        });
    }

    submit = () => {
        const { isLoggedIn, submitExternalRxTransfer } = this.props;
        if (isLoggedIn) {
            const { transferData } = this.state;
            if (!transferData.isInsurance) {
                transferData.InsuranceDetail = {};
            }
            submitExternalRxTransfer(transferData, this.onSubmitComplete);
            logUI("MBHWeb.Rx.Transfer.External.Submit", new Date(), Tools.getURLPath(), JSON.stringify({ transferData }));
        }
    }

    onSubmitComplete = (response, error) => {
        if (response && response.SuccessRx && !response.FailureRx) {
            this.setState({ transferData: { ...this.state.transferData, touched: false }, transferCompleted: true });
        }
        else {
            this.setState({ transferCompleted: true });
        }
    }

    onNewRequest = (reload) => {
        this.setState({ transferCompleted: false }, () => {
            if (reload) {
                this.loadData();
            }

            this.refs.stepManager.wrappedInstance.refresh();
        });
    }

    scrollToTop = (success) => {
        if (success && typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }

    blockNavigation(nextLocation) {
        const re = /Transfer$/;
        return nextLocation && re.test(nextLocation.pathname);
    }

    render() {
        const { transferResult, hasPharmacyLogin, currentPharmacyUser } = this.props;
        const { transferData, destinationPharmacy, transferCompleted, hideModal } = this.state;
        const containerClassName = ((hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId)) ? '' : ' unlinked-rx-account');

        return (
            <div className={"container-fluid body-content non-bsw-transfer-container full-width" + containerClassName}>
                <div className="row">
                    {!transferCompleted
                        ? <React.Fragment>
                            <div className="col-12 maxWidth-content">
                                <div className="row">
                                    <PharmacyHeader />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 progtrckr-divider" />
                                    <div className="col-12 maxWidth-content">
                                        <div className="step-progress">
                                            <OurStepManager ref="stepManager" baseURL={this.baseURL} backButtonCls="hidden" nextButtonCls="btn btn-primary" onStepChange={this.scrollToTop}>
                                                <NonBSWPharamacyInfo steptitle="Enter Pharmacy Info" transferData={transferData} onChange={transferData => this.setState({ transferData })} />
                                                <TransferPharmacy steptitle='Select Pharmacy' shouldHideContinueButton destinationPharmacy={destinationPharmacy} onPharmacySelected={this.onPharmacySelected} />
                                                <TransferReview steptitle="Review & Submit" continueButtonText="Submit" onSubmit={this.submit} rxList={transferData.PrescriptionInfo}
                                                    destinationPharmacy={destinationPharmacy} addressUrl={this.addressUrl} waiting={transferResult && transferResult.waiting}
                                                />
                                            </OurStepManager>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                        : <div className="col-12">
                            <TransferConfirmation isExternal transfer={transferResult} sourcePharmacy={transferData.ExternalPharmacyDetail} destinationPharmacy={destinationPharmacy} rxList={transferData.PrescriptionInfo}
                                addressUrl={this.addressUrl} onNewRequest={this.onNewRequest}
                            />
                        </div>
                    }
                </div>
                {!hideModal && transferData.touched && <ConfirmationModal when={transferData.touched} blockNavigation={this.blockNavigation} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        transferResult: state.pharmacy.transferExternal,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        isLoggedIn: state.sso.isLoggedIn
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitExternalRxTransfer: (request, callback) => {
            dispatch({ type: types.EXTERNAL_RX_TRANSFER_START, request, callback });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NonBSWTransfer);